import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBaseButton, LazyBaseDialog, LazyBaseErrorNotification, LazyBaseInput, LazyCNuxtImg, LazyISvg, LazyMainHeader, LazyPageTemplate, LazyTextButton, LazyIconAnswerCheck, LazyIconArrow, LazyIconArrowAmount, LazyIconArrowCircle, LazyIconAttention, LazyIconBloodFlow, LazyIconCertified, LazyIconChallenges, LazyIconChecked, LazyIconChevron, LazyIconChevronSlider, LazyIconClose, LazyIconCollapseArrow, LazyIconCompleteScreenCheck, LazyIconConfidence, LazyIconCreatedByExperts, LazyIconDailyRoutine, LazyIconDifficulty, LazyIconDozen, LazyIconDuration, LazyIconEjaculation, LazyIconEquipment, LazyIconErectile, LazyIconGoalLpV13, LazyIconHand, LazyIconHeartsLpV13, LazyIconHelp, LazyIconIllustrations, LazyIconImprovement, LazyIconInfo, LazyIconInsights, LazyIconInstructionsVideoAudio, LazyIconLock, LazyIconLpV12DozenOfSessions, LazyIconLpV12Insights, LazyIconMailSent, LazyIconMind, LazyIconMotivation, LazyIconMusclesStrength, LazyIconOrangePriceBg, LazyIconOverallHealth, LazyIconOverviews, LazyIconPaymentSuccess, LazyIconPlanOrangeCheck, LazyIconProgressAccess, LazyIconProgressUpgrades, LazyIconProgress, LazyIconProstate, LazyIconQuestion, LazyIconQuestionRed, LazyIconRatingTrust, LazyIconRedFlag, LazyIconRelationshipHappiness, LazyIconReminder, LazyIconSchedule, LazyIconSecure, LazyIconSound, LazyIconSound1, LazyIconStarsIcons, LazyIconTaphereEmail, LazyIconTimeLpV13, LazyIconTrending, LazyIconVerified, LazyIconWatchLpV13, LazyIconWhatsapp, LazyIconWrite, LazyIconYellowStar, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["BaseButton", LazyBaseButton],
["BaseDialog", LazyBaseDialog],
["BaseErrorNotification", LazyBaseErrorNotification],
["BaseInput", LazyBaseInput],
["CNuxtImg", LazyCNuxtImg],
["ISvg", LazyISvg],
["MainHeader", LazyMainHeader],
["PageTemplate", LazyPageTemplate],
["TextButton", LazyTextButton],
["IconAnswerCheck", LazyIconAnswerCheck],
["IconArrow", LazyIconArrow],
["IconArrowAmount", LazyIconArrowAmount],
["IconArrowCircle", LazyIconArrowCircle],
["IconAttention", LazyIconAttention],
["IconBloodFlow", LazyIconBloodFlow],
["IconCertified", LazyIconCertified],
["IconChallenges", LazyIconChallenges],
["IconChecked", LazyIconChecked],
["IconChevron", LazyIconChevron],
["IconChevronSlider", LazyIconChevronSlider],
["IconClose", LazyIconClose],
["IconCollapseArrow", LazyIconCollapseArrow],
["IconCompleteScreenCheck", LazyIconCompleteScreenCheck],
["IconConfidence", LazyIconConfidence],
["IconCreatedByExperts", LazyIconCreatedByExperts],
["IconDailyRoutine", LazyIconDailyRoutine],
["IconDifficulty", LazyIconDifficulty],
["IconDozen", LazyIconDozen],
["IconDuration", LazyIconDuration],
["IconEjaculation", LazyIconEjaculation],
["IconEquipment", LazyIconEquipment],
["IconErectile", LazyIconErectile],
["IconGoalLpV13", LazyIconGoalLpV13],
["IconHand", LazyIconHand],
["IconHeartsLpV13", LazyIconHeartsLpV13],
["IconHelp", LazyIconHelp],
["IconIllustrations", LazyIconIllustrations],
["IconImprovement", LazyIconImprovement],
["IconInfo", LazyIconInfo],
["IconInsights", LazyIconInsights],
["IconInstructionsVideoAudio", LazyIconInstructionsVideoAudio],
["IconLock", LazyIconLock],
["IconLpV12DozenOfSessions", LazyIconLpV12DozenOfSessions],
["IconLpV12Insights", LazyIconLpV12Insights],
["IconMailSent", LazyIconMailSent],
["IconMind", LazyIconMind],
["IconMotivation", LazyIconMotivation],
["IconMusclesStrength", LazyIconMusclesStrength],
["IconOrangePriceBg", LazyIconOrangePriceBg],
["IconOverallHealth", LazyIconOverallHealth],
["IconOverviews", LazyIconOverviews],
["IconPaymentSuccess", LazyIconPaymentSuccess],
["IconPlanOrangeCheck", LazyIconPlanOrangeCheck],
["IconProgressAccess", LazyIconProgressAccess],
["IconProgressUpgrades", LazyIconProgressUpgrades],
["IconProgress", LazyIconProgress],
["IconProstate", LazyIconProstate],
["IconQuestion", LazyIconQuestion],
["IconQuestionRed", LazyIconQuestionRed],
["IconRatingTrust", LazyIconRatingTrust],
["IconRedFlag", LazyIconRedFlag],
["IconRelationshipHappiness", LazyIconRelationshipHappiness],
["IconReminder", LazyIconReminder],
["IconSchedule", LazyIconSchedule],
["IconSecure", LazyIconSecure],
["IconSound", LazyIconSound],
["IconSound1", LazyIconSound1],
["IconStarsIcons", LazyIconStarsIcons],
["IconTaphereEmail", LazyIconTaphereEmail],
["IconTimeLpV13", LazyIconTimeLpV13],
["IconTrending", LazyIconTrending],
["IconVerified", LazyIconVerified],
["IconWatchLpV13", LazyIconWatchLpV13],
["IconWhatsapp", LazyIconWhatsapp],
["IconWrite", LazyIconWrite],
["IconYellowStar", LazyIconYellowStar],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
